import React, { useRef, useEffect, JSX } from 'react';

type Props = {
    searchText: string;
    setSearchText: (searchText: string) => void;
    isLoading: boolean;
};

const FolderSelectorInput = ({ searchText, setSearchText, isLoading }: Props): JSX.Element => {
    const searchInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (!isLoading) {
            searchInputRef?.current?.focus();
        }
    }, [isLoading]);

    return (
        <>
            <input
                aria-label="Input new folder"
                className="w-full px-3 py-2 mb-4 overflow-x-scroll border border-gray-400 border-solid rounded"
                onChange={({ target }) => setSearchText(target.value)}
                placeholder="Find or Create New Folder"
                ref={searchInputRef}
                type="text"
                value={searchText}
            />
        </>
    );
};

export default FolderSelectorInput;
